<template>
    <div>
        <v-dialog v-model="storageType" class="storage-type-dialog" width="500px" persistent>
            <v-card>
                <v-card-title>
                    <h3>{{ $t('Выберите тип хранилища ключа для ЭЦП') }}</h3>
                </v-card-title>
                <v-card-text>
                    <v-select v-model="selectedTypeOfStorage" :items="typeOfStorages" :label="$t('Выберите')" class="pl-2 pr-2"></v-select>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="onCloseECPDialog(false)">{{ $t('Отмена') }}</v-btn>
                    <v-btn :disabled="!selectedTypeOfStorage" flat @click="onCloseECPDialog(true)">{{ $t('Продолжить') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <transition name="fade" mode="out-in">
            <TreeView
                v-if="!requestTypeSelected"
                title="Выберите тип заявки для подачи"
                v-bind:items="availableProcesses"
                v-bind:itemsLoading="processesListLoading"
                v-on:itemSelect="handleItemSelect"
            />
            <!-- <v-card class="card-container elevation-12"> -->
            <RequestForm
                v-if="requestTypeSelected"
                v-bind:title="$t(processName)"
                v-bind:isLoading="requestLoading"
                v-bind:isLoadingMessage="isLoadingMessage"
                v-bind:vfgSchema="localRequestSchema"
                v-bind:vfgModel="localRequestData"
                v-bind:actions="translatedLocalActions"
                v-bind:errorMessage="errorMessage"
                :showInfoMessage="true"
                :showAgreeCheckBox="isConsumer"
                v-on:submitOK="handleSubmitOK"
                v-on:submitCancel="handleSubmitCancel"
                v-on:submitSaveDraft="submitSaveDraft"
            />

            <!-- </v-card> -->
        </transition>
        <!-- <input type="submit" value="MyButton"> -->
        <!-- </v-form> -->
        <!-- </form> -->
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import TreeView from '../components/TreeView';
import RequestForm from '../components/RequestForm';
import { transformToOneLevel, objectToBase64String } from '../utility/routines';
import { createCAdESFromBase64 } from '../services/sign.service';
import moment from 'moment';
import {
    BLOCK_METER_INDICATIONS_DATA_ONE,
    BLOCK_METER_INDICATIONS_DATA_TWO,
    BLOCK_METER_INDICATIONS,
    BLOCK_METER_INDICATIONS_DATA,
    BLOCK_METER_INDICATIONS_DAY,
    BLOCK_METER_INDICATIONS_NIGHT,
    BLOCK_MAIN_DATA,
    BLOCK_ANSWER_DATA,
    BLOCK_FILES_REQUIRED,
    TYPE_PROCESS_TARIFF_CHANGE,
    TYPE_PROCESS_SEAL_INSTALL
} from '../config/consts';

import MobileDetect from "mobile-detect";

export default {
    name: 'Request',
    components: { TreeView, RequestForm },
    data: () => ({
        saveNewRequestResult: null,
        errorMessage: '',
        isLoadingMessage: '',
        requestTypeSelected: false,
        localRequestData: {},
        localRequestSchema: [],
        selectedTypeOfStorage: 'PKCS12',
        selectedTypeOfStoragePromiseResolve: undefined,
        storageType: false,
        localActions: [
            {
                code: 'submitOK',
                title: 'Отправить',
                color: 'primary',
                Type: 'submit',
                disabled: false
            },
            {
                code: 'submitSaveDraft',
                title: 'Сохранить черновик',
                color: '',
                Type: 'button',
                disabled: false
            },
            {
                code: 'submitCancel',
                title: 'Закрыть без сохранения',
                color: '',
                Type: 'reset',
                disabled: false
            }
        ]
    }),
    computed: {
        ...mapState('bpm', ['processesListLoading']),
        ...mapGetters('bpm', ['availableProcesses']),
        ...mapGetters('request', ['processDocumentFolderID', 'processName', 'processId', 'visibleRequestSchema']),
        ...mapState('request', ['needSign', 'requestLoading', 'requestData']),
        ...mapGetters('user', ['userFullName', 'userEmail', 'getFolderForRequests', 'isConsumer', 'isROESUser', 'isRESUser', 'userNeedSign', 'userAccounts']),
        needSignLocal: function () {
            return this.needSign && this.userNeedSign;
        },
        typeOfStorages() {
            return [
                { text: this.$t('Ваш Компьютер'), value: 'PKCS12' },
                { text: this.$t('Казтокен'), value: 'AKKaztokenStore' },
                { text: this.$t('Личное Удостоверение'), value: 'AKKZIDCardStore' },
                { text: this.$t('EToken Java 72k'), value: 'AKEToken72KStore' },
                { text: this.$t('AK JaCarta'), value: 'AKJaCartaStore' }
            ];
        },
        translatedLocalActions() {
            let actions = this.localActions.map(action => {
                action.title = this.$t(action.title);
                return action;
            });

            return actions;
        }
    },
    watch: {},
    methods: {
        ...mapActions('bpm', ['intiProcessesList', 'completeProcess']),
        ...mapActions('user', ['addAccountsToSchema', 'getAccountInfo', 'getAccountCntInfo', 'getAccountTariffInfo', 'getAccountUnsealInfo']),
        ...mapActions('request', [
            'createNewRequest',
            'saveNewRequest',
            'updateRequest',
            'saveDraft',
            'clearRequest',
            'uploadRequiredFiles',
            'swithRequestLoading',
            'getAcceptDocuments',
            'getEdsInfo'
        ]),
        getDataForSign() {
            let dataForSign = {};
            for (let key in this.localRequestData) {
                if (key !== BLOCK_MAIN_DATA && key !== BLOCK_ANSWER_DATA) {
                    dataForSign[key] = this.localRequestData[key];
                }
            }
            return dataForSign;
        },
        async getAccountUnsealInfoLocal(accountNumber) {
            this.$set(this.localRequestData.accountsData, 'unsealDate', undefined);
            this.$set(this.localRequestData.accountsData, 'unsealPlace', undefined);
            this.$set(this.localRequestData.accountsData, 'sealNumber', undefined);

            let res = await this.getAccountUnsealInfo(accountNumber);
            this.$set(this.localRequestData.accountsData, 'unsealDate', res.date_id ? moment(String(res.date_id)).format('DD.MM.YYYY') : undefined);
            this.$set(this.localRequestData.accountsData, 'unsealPlace', res.place_name);
            this.$set(this.localRequestData.accountsData, 'sealNumber', res.seal_number);
        },
        async accountNumberNotChangedForPause() {
            let accountNumberBefore = this.localRequestData.accountsData.account_number;
            await new Promise(r => setTimeout(r, 500));
            return accountNumberBefore === this.localRequestData.accountsData.account_number;
        },
        async updateCntIndicationsInfo(accountNumber) {
            let indications = this.localRequestData.meterIndicationsData || {};
            this.$set(this.localRequestData, 'meterIndicationsData', {});
            let res = await this.getAccountCntInfo(accountNumber);

            if (res) {
                indications.meterName = res.cnt_factory_number;
                indications.lastIndicationsDate = res.indications_date_id ? moment(String(res.indications_date_id)).format('DD.MM.YYYY') : undefined;
                indications.lastIndications = res.indications_1;
                indications.lastIndicationsDay = res.indications_1;
                indications.lastIndicationsNight = res.indications_2;
            } else {
                indications.meterName = undefined;
                indications.lastIndicationsDate = undefined;
                indications.lastIndications = undefined;
                indications.lastIndicationsDay = undefined;
                indications.lastIndicationsNight = undefined;
            }

            this.$set(this.localRequestData, 'meterIndicationsData', indications);
        },
        async getAccountTariffInfoLocal(accountNumber) {
            let res = await this.getAccountTariffInfo(accountNumber);
            this.$set(this.localRequestData.accountsData, 'currentTariff', res.current_tariff);
            this.$set(this.localRequestData.accountsData, 'newTariff', res.tariff_to_change);
        },
        async getAccountInfoLocal(accountNumber, identityCardField) {
            let accountInfo = await this.getAccountInfo(accountNumber);
            if (accountInfo.account_id) {
                this.localActions[0].disabled = false;
                this.$set(identityCardField, 'visible', !accountInfo.identity_card);
                if (accountInfo.identity_card) {
                    delete this.localModel.requestFiles.IdentityCard;
                }
            }
        },
        async handleItemSelect(value) {
            this.requestTypeSelected = true;

            await this.createNewRequest({ processDocumentFolderID: value.id, userData: { userFullName: this.userFullName, userEmail: this.userEmail } });
            this.localRequestSchema = this.visibleRequestSchema;
            this.localRequestData = this.requestData;

            let meterIndicationsDataOne = this.localRequestSchema.find(schema => schema.code === BLOCK_METER_INDICATIONS_DATA_ONE);
            let meterIndicationsDataTwo = this.localRequestSchema.find(schema => schema.code === BLOCK_METER_INDICATIONS_DATA_TWO);

            if (meterIndicationsDataOne && meterIndicationsDataTwo) {
                let requestFilesBlock = this.localRequestSchema.find(schema => schema.code === BLOCK_FILES_REQUIRED);
                let identityCardField = requestFilesBlock.schema.fields.find(field => field.model === 'requestFiles.IdentityCard');

                this.$set(meterIndicationsDataTwo, 'hide', true);
                if (this.isROESUser || this.isRESUser) {
                    this.localActions[0].disabled = true;
                    this.$watch('localRequestData.accountsData.account_number', async () => {
                        this.localActions[0].disabled = true;
                        this.$set(identityCardField, 'visible', true);
                        if (await this.accountNumberNotChangedForPause()) {
                            //not changed throughout 3 sec
                            this.getAccountInfoLocal(this.localRequestData.accountsData.account_number, identityCardField);

                            await this.updateCntIndicationsInfo(this.localRequestData.accountsData.account_number);
                        }
                    });
                } else {
                    this.$watch('localRequestData.accountsData.account_number', () => {
                        if (
                            this.localRequestData.accountsData &&
                            this.localRequestData.accountsData.account_number &&
                            typeof this.localRequestData.accountsData.account_number === 'object'
                        ) {
                            let showFirst = this.localRequestData.accountsData.account_number.indications_count == 1;

                            this.$set(meterIndicationsDataOne, 'hide', !showFirst);
                            this.$set(meterIndicationsDataTwo, 'hide', showFirst);

                            try {
                                if (showFirst) {
                                    delete this.localRequestData[BLOCK_METER_INDICATIONS_DATA][BLOCK_METER_INDICATIONS_DAY];
                                    delete this.localRequestData[BLOCK_METER_INDICATIONS_DATA][BLOCK_METER_INDICATIONS_NIGHT];
                                } else {
                                    delete this.localRequestData[BLOCK_METER_INDICATIONS_DATA][BLOCK_METER_INDICATIONS];
                                }
                            } catch (e) {
                                console.log(e);
                            }

                            this.updateCntIndicationsInfo(this.localRequestData.accountsData.account_number.account_id);

                            //при передаче показаний если у выбранного лс identity_card ==false то скрываем поле уд.лич
                            if (identityCardField) {
                                this.$set(identityCardField, 'visible', !this.localRequestData.accountsData.account_number.identity_card);
                            }
                        }
                    });
                }
            } else if (this.processName === TYPE_PROCESS_TARIFF_CHANGE) {
                if (this.isROESUser || this.isRESUser) {
                    this.$watch('localRequestData.accountsData.account_number', async () => {
                        if (await this.accountNumberNotChangedForPause()) {
                            this.getAccountTariffInfoLocal(this.localRequestData.accountsData.account_number);
                        }
                    });
                } else {
                    this.$watch('localRequestData.accountsData.account_number', async () => {
                        if (
                            this.localRequestData.accountsData &&
                            this.localRequestData.accountsData.account_number &&
                            typeof this.localRequestData.accountsData.account_number === 'object'
                        ) {
                            this.getAccountTariffInfoLocal(this.localRequestData.accountsData.account_number.account_id);
                        }
                    });
                }
            } else if (this.processName === TYPE_PROCESS_SEAL_INSTALL) {
                if (this.isROESUser || this.isRESUser) {
                    this.$watch('localRequestData.accountsData.account_number', async () => {
                        if (await this.accountNumberNotChangedForPause()) {
                            this.getAccountUnsealInfoLocal(this.localRequestData.accountsData.account_number);
                        }
                    });
                } else {
                    this.$watch('localRequestData.accountsData.account_number', async () => {
                        if (
                            this.localRequestData.accountsData &&
                            this.localRequestData.accountsData.account_number &&
                            typeof this.localRequestData.accountsData.account_number === 'object'
                        ) {
                            this.getAccountUnsealInfoLocal(this.localRequestData.accountsData.account_number.account_id);
                        }
                    });
                }
            }

            this.addAccountsToSchema({ schemaIn: this.localRequestSchema });
            this.setProcessName(this.processName);
        },
        async selectTypeOfStorage() {
            let outer = this;
            return new Promise(function (resolve) {
                outer.selectedTypeOfStoragePromiseResolve = resolve;
            });
        },
        onCloseECPDialog(isContinue) {
            this.storageType = false;
            this.selectedTypeOfStoragePromiseResolve(isContinue);
            this.selectedTypeOfStoragePromiseResolve = undefined;
        },
        async handleSubmitOK() {
            let objectAccountNumber = null;
            try {
                this.errorMessage = '';
                this.swithRequestLoading(true);

                if (this.localRequestData.accountsData && this.localRequestData.accountsData.account_number) {
                    if (typeof this.localRequestData.accountsData.account_number === 'object') {
                        objectAccountNumber = this.localRequestData.accountsData.account_number;
                        this.localRequestData.accountsData.accountName = objectAccountNumber.account_name;
                        this.localRequestData.accountsData.address = objectAccountNumber.address;
                        this.localRequestData.accountsData.account_number = objectAccountNumber.account_id;
                        this.localRequestData.accountsData.roes = objectAccountNumber.roes_code_name;
                        this.localRequestData.accountsData.roes_name___Ru = objectAccountNumber.roes_div_name;
                        this.localRequestData.accountsData.roes_name___Kk = objectAccountNumber.roes_div_name_kz;
                        this.localRequestData.accountsData.res = objectAccountNumber.res_code_name;
                        this.localRequestData.accountsData.res_name___Ru = objectAccountNumber.res_div_name;
                        this.localRequestData.accountsData.res_name___Kk = objectAccountNumber.res_div_name_kz;
                    } else {
                        //roes user creating request
                        let accountInfo = await this.getAccountInfo(this.localRequestData.accountsData.account_number);
                        if (accountInfo.account_id) {
                            this.localRequestData.accountsData.accountName = accountInfo.account_name;
                            this.localRequestData.accountsData.address = accountInfo.address;
                            this.localRequestData.accountsData.roes = accountInfo.roes_code_name;
                            this.localRequestData.accountsData.roes_name___Ru = accountInfo.roes_div_name;
                            this.localRequestData.accountsData.roes_name___Kk = accountInfo.roes_div_name_kz;
                            this.localRequestData.accountsData.res = accountInfo.res_code_name;
                            this.localRequestData.accountsData.res_name___Ru = accountInfo.res_div_name;
                            this.localRequestData.accountsData.res_name___Kk = accountInfo.res_div_name_kz;
                        } else {
                            this.errorMessage = this.$t('Такой лицевой счет не существует');
                            return;
                        }
                    }
                }

                if (!(await this.uploadRequiredFiles(this.localRequestData))) {
                    //show dialog with upload error
                    this.swithRequestLoading(false);
                    this.errorMessage = this.$t('Ошибка загрузки файла. Пожалуйста, попробуйте еще раз.');
                    return;
                }

                if (this.needSignLocal) {
                    try {
                      //Проверяем, если мобильное устройство, то ошибка
                      const md = new MobileDetect(window.navigator.userAgent);

                      //if(window.innerWidth <= 768){
                      if (md.mobile()) {
                        this.errorMessage = this.$t('validators.isMobile');
                        return;
                      }
                      //-----------------------------------------
                        this.isLoadingMessage = this.$t('Подтверждение заявки ЭЦП');
                        this.storageType = true;
                        if (await this.selectTypeOfStorage()) {
                            let res = await createCAdESFromBase64(objectToBase64String(this.getDataForSign()), this.selectedTypeOfStorage);
                            if (res) {
                                if (res === 'notConnected') {
                                    this.errorMessage = this.$t('Ошибка при подключении к NCALayer.');
                                    return;
                                } else if (res === 'storage.empty') {
                                    this.errorMessage = this.$t('Выбранный тип хранилища пуст.');
                                    return;
                                }
                                this.localRequestData.mainData.sign = res;
                                this.localRequestData.mainData.signedDateTime = moment().format();
                            } else {
                                return;
                            }
                        } else {
                            return;
                        }

                        // Для акцепта делаем валидацию эцп
                        if (this.localRequestData.hasOwnProperty('acceptData')) {
                          const edsUser = await this.getEdsInfo(this.requestData);
                          const requestAccount = this.requestData.accountsData.account_number;
                          const account = this.userAccounts.find(item => item.account_id === requestAccount);
                          if(!account || account.iin !== edsUser.iin){
                            this.errorMessage = this.$t('validators.iinNotMatch');
                            return;
                          }
                        }

                    } finally {
                        this.isLoadingMessage = '';
                    }
                }

                // Для акцепта подтягиваем документы с бэка
                if (this.localRequestData.hasOwnProperty('acceptData')) {
                  await this.getAcceptDocuments();
                }

                if (this.saveNewRequestResult) {
                    //document already created

                    if (
                        !(await this.updateRequest({
                            requestId: this.saveNewRequestResult.documentId,
                            requestData: this.localRequestData,
                            folderId: this.saveNewRequestResult.folderId
                        }))
                    ) {
                        //show dialog with update error
                        this.swithRequestLoading(false);
                        this.errorMessage = this.$t('Ошибка обновления запроса. Пожалуйста, попробуйте еще раз.');
                        return;
                    }
                } else {
                    let folderId = this.getFolderForRequests(this.processId);
                    let saveResult = await this.saveNewRequest({ requestData: this.localRequestData, folderId: folderId });
                    if (saveResult) {
                        this.saveNewRequestResult = saveResult;
                        this.saveNewRequestResult.folderId = folderId;
                    } else {
                        this.errorMessage = this.$t('Ошибка сохранения запроса. Пожалуйста, попробуйте еще раз.');
                        return;
                    }
                }

                let data = transformToOneLevel(this.localRequestData);
                data.id = this.saveNewRequestResult.documentId;
                let completeResponce = await this.completeProcess({ processId: this.saveNewRequestResult.processId, data: data });
                if (completeResponce.success) {
                    this.clearRequestData();
                    this.$router.push('/');
                } else {
                    //show message with complete error
                    this.swithRequestLoading(false);
                    this.errorMessage = completeResponce.message;
                }
            } catch (e) {
                console.log(e);
            } finally {
                this.swithRequestLoading(false);
                if (this.localRequestData.accountsData && this.localRequestData.accountsData.account_number && objectAccountNumber) {
                    this.localRequestData.accountsData.account_number = objectAccountNumber;
                }
            }
        },
        async submitSaveDraft() {
            let objectAccountNumber = null;
            this.swithRequestLoading(true);
            try {
                if (
                    this.localRequestData.accountsData &&
                    this.localRequestData.accountsData.account_number &&
                    typeof this.localRequestData.accountsData.account_number === 'object'
                ) {
                    objectAccountNumber = this.localRequestData.accountsData.account_number;
                    this.localRequestData.accountsData.account_number = objectAccountNumber.account_id;
                }

                let folderId = this.getFolderForRequests(this.processId);
                let uploadResult = await this.uploadRequiredFiles(this.localRequestData);
                let saveResult = await this.saveDraft({ requestData: this.localRequestData, folderId: folderId });
                if (uploadResult && saveResult) {
                    this.clearRequestData();
                    this.$router.push('/');
                }
            } catch (e) {
                console.log(e);
            } finally {
                this.swithRequestLoading(false);
                if (this.localRequestData.accountsData && this.localRequestData.accountsData.account_number && objectAccountNumber) {
                    this.localRequestData.accountsData.account_number = objectAccountNumber;
                }
            }
        },
        async handleSubmitCancel() {
            this.clearRequestData();
            this.requestTypeSelected = false;
        },
        clearRequestData() {
            this.localRequestSchema = [];
            this.localRequestData = {};
            this.errorMessage = '';
            this.localActions[0].disabled = false;
            this.clearRequest();
            this.selectedTypeOfStorage = 'PKCS12';
            this.selectedTypeOfStoragePromiseResolve = undefined;
        },

        setProcessName(processName) {
            this.localRequestData.mainData.requestType = processName;
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.intiProcessesList();
        });
    }
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
    opacity: 0;
}
</style>